import { Grid, Typography } from '@material-ui/core';
import React, { Dispatch, SetStateAction } from 'react';
import ChartAnnotation from './ChartAnnotation';
import ChartTitles from './Charts/ChartTitles';
import NoClientDomain from './Charts/NoClientDomain';
import { AnalysisListItem } from './AnalysisList';
import { DownloadAnalysisTheme } from '../../graphql/projects/mutations/projects/useDownloadAnalysisGq';
import { Language } from './internationalText';
import { ProjectGq } from '../../graphql/projects/models/ProjectGq';
import { AnalysisFilterState } from './Filter/analysisFilterState';
import { ColorPalette } from './Palette/ColorPalette';

export interface ChartContainerProps {
  chart: AnalysisListItem;
  slideTheme: DownloadAnalysisTheme;
  language: Language;
  project: ProjectGq;
  analysisFilterState: AnalysisFilterState;
  setAnalysisFilterState: Dispatch<SetStateAction<AnalysisFilterState>>;
  palette: ColorPalette;
  skipAnimation?: boolean;
  emptyOnFail?: boolean;
  panelIsLink?: boolean;
  setSelectedAnalysisId?: Dispatch<SetStateAction<string>>;
}

export const ChartContainer: React.FC<ChartContainerProps> = ({
  chart,
  slideTheme,
  project,
  analysisFilterState,
  language,
  setAnalysisFilterState: setAnalysisState,
  palette,
  skipAnimation,
  emptyOnFail,
  panelIsLink,
  setSelectedAnalysisId,
}) => {
  const ChartComponent = chart?.chart;
  return (
    <>
      <div
        className={`
          w-full px-4 pt-12 pb-8 mb-1 drop-shadow bg-white rounded-lg
          ${panelIsLink && 'cursor-pointer'}
        `}
        data-screenshot-id="chart"
        onClick={panelIsLink ? () => setSelectedAnalysisId(chart.downloadId) : undefined}
      >
        <Grid container justifyContent="center" spacing={3}>
          <Grid item xs={12}>
            <ChartTitles title={chart.title} subtitle={chart.subtitle} slideTheme={slideTheme} />
            <ChartAnnotation
              language={language}
              analysisFilterState={analysisFilterState}
              project={project}
              slideTheme={slideTheme}
            />
          </Grid>
          <Grid item xs={chart.wideChart ? 11 : 10}>
            {chart.clientDomainRequired && <NoClientDomain />}
            {!chart.clientDomainRequired && (
              <ChartComponent
                language={language}
                project={project}
                title={chart.title}
                subtitle={chart.subtitle}
                analysisFilterState={analysisFilterState}
                setAnalysisFilterState={setAnalysisState}
                palette={palette}
                skipAnimation={skipAnimation}
                emptyOnFail={emptyOnFail}
              />
            )}
          </Grid>
        </Grid>
      </div>
      {chart.footnote && (
        <Typography variant="caption" gutterBottom>
          * {chart.footnote}
        </Typography>
      )}
    </>
  );
};

export default ChartContainer;
